import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

const options = [
  { label: 'Pendente', value: 'pending' },
  { label: 'Realizado', value: 'done' },
];

export const useRedirectedProductSapStatusOptions = () => {
  return {
    singleSelectOptions: options.map(optionsMapper),
    multiSelectOptions: options.map(multiSelectorOptionsMapper),
  }
}